import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=fd9ec298&scoped=true"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTopButton.vue?vue&type=style&index=0&id=fd9ec298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9ec298",
  null
  
)

export default component.exports